import { gsap } from "gsap";

class Header {

    constructor (params) {
        // Init variables
	    this.$cache       = {};
	    this.$cache.main  = params.target;
		this.mbIsOpen = false;
		
		// Trigger init functions
		this.initCache();
		this.initEventsConst();
		this.registerEvents();
    }
	
	initCache() {
		this.$cache.window = $(window);
		this.$cache.html = $('html');
		this.$cache.body = this.$cache.html.find('body');
		this.$cache.wrap = this.$cache.body.find('.wrap');
		
		this.$cache.right = this.$cache.main.find('.hi-right');
		this.$cache.burger = this.$cache.right.find('.burger-nav');
		this.$cache.subMb = this.$cache.main.find('.hi-mb');
		this.$cache.subMbInner = this.$cache.subMb.find('.himb-inner');
		this.$cache.subMbNav = this.$cache.subMbInner.find('.scroll-nav');
	}
	
	initEventsConst() {
		this.scrollEvent = () => this.fixedToggle();
		this.toggleNavMbEvent = (e) => this.toggleNavMb(e);
	}
	
	registerEvents() {
		this.$cache.window.on('scroll', this.scrollEvent);
		this.$cache.burger.on('click', this.toggleNavMbEvent);
	}

    resize() {
    	this.fixedToggle();
    }
	
	fixedToggle() {
		let scrollTop = this.$cache.window.scrollTop();
		
		if(scrollTop === 0) {
			this.$cache.main.removeClass('is-fixed');
		} else {
			this.$cache.main.addClass('is-fixed');
		}
	}
	
	toggleNavMb(e) {
		e.preventDefault();
	
		if(this.mbIsOpen) {
			this.closeNavMb();
		} else {
			this.openNavMb();
		}
	}
	
	closeNavMb() {
		if(!this.mbIsOpen) return false;
		
		let tl = new gsap.timeline({paused: true, onStart: () => {
			this.mbIsOpen = false;
			this.$cache.burger.removeClass('is-cross');
		}, onComplete: () => {
			this.$cache.main.removeClass('sub-is-open');
		}});
		
		tl.to(this.$cache.subMbNav, {duration: 0.4, opacity: 0, ease: "expo.out"}, 0.1);
		tl.to(this.$cache.subMbInner, {duration: 0.5, paddingTop: 0, ease: "quad.out"}, 0);
		tl.to(this.$cache.subMbInner, {duration: 0.5, height: 0, ease: "quad.out"}, 0);
		
		tl.play();
	}
	
	openNavMb() {
		if(this.mbIsOpen) return false;		
		this.mbIsOpen = true;
		this.$cache.main.addClass('sub-is-open');
		this.$cache.burger.addClass('is-cross');
		
		let h = this.$cache.subMbNav.outerHeight(true);
		let tl = new gsap.timeline({paused: true});

		tl.to(this.$cache.subMbInner, 0.5, {height: h, force3D: true, ease: "quad.out"}, 0.05);
		tl.to(this.$cache.subMbInner, 0.5, {paddingTop: 25, force3D: true, ease: "quad.out"}, 0.05);
		tl.fromTo(this.$cache.subMbNav, 0.5, {opacity: 0}, {opacity: 1, ease: "quad.inOut"}, 0.15);
		
		tl.play();
	}
}

export default Header;


// WEBPACK FOOTER //
// ./scripts/components/header.js